/** Dispatched after the Meta Pixel bootstrap script runs `fbq('init', …)`. */
export const META_PIXEL_READY_EVENT = 'ft:meta-pixel-ready';
